<template>
    <div class="gpt-prompt-library">
            <div class="gpt-library-head">
                <h3>Prompt Library</h3>
                <v-btn @click="CloseLibrary()" fab small><v-icon size="22px" color="#333">mdi-close</v-icon></v-btn>
            </div>
            <div class="prompt-library-inner">
                <div class="prompt-library-inner-search">
                    <v-text-field v-model="search" placeholder="Search..." class="text-field-search"></v-text-field>
                    <v-select :items="items" label="Category" density="compact"></v-select>
                </div>
                <div class="prompt-table">
                    <table>
                        <thead>
                            <tr>
                                <th scope="col">Category</th>
                                <th scope="col">Prompt</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="j in 9" :key="j">
                                <td>Basic Info</td>
                                <td>Provide me with a selection of speakers who have expertise about law firm</td>
                                <td>
                                    <span><v-icon>mdi-heart-outline</v-icon></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
</template>
<script>
export default {
    components: {
    },
    props: {
        visible: {
        type: Boolean,
        required: true
        }
    },
    data() {
        return {
            items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
        }
    },
    computed: {
        
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        CloseLibrary(){
            this.$parent.PromptLibraryOpen = false; 
        }
    },

}
</script>